export default "__VITE_ASSET__DD2CBToD__"